<template>
    <RegionDetails/>
</template>
<script>
import RegionDetails from '../../components/regions/RegionDetails';

export default {
  components: {
    RegionDetails,
  },
};
</script>
